import React from 'react'
import Image from 'gatsby-image'
import { FaRegClock } from 'react-icons/fa'
import { IoMdArrowRoundForward } from 'react-icons/io'
import { Link } from 'gatsby'
import styled from 'styled-components'
import Difficulty from '../Difficulty'
import { motion } from 'framer-motion'

const Project = ({ frontmatter }) => {
  const {
    title,
    image,
    slug,
    date,
    category,
    readTime,
    excerpt,
    difficulty,
  } = frontmatter
  return (
    <Wrapper>
      {/* <div className="grid"> */}
      <Image fluid={image.childImageSharp.fluid} className="img" />
      <div className="info">
        {/* <span>{category}</span> */}
        <h3>{title}</h3>
        <div className="underline"></div>
        <p>{excerpt}</p>
        <Difficulty difficulty={difficulty} />
        <div className="link-container">
          <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
            <Link to={`/projects/${slug}`} className="link">
              Project Info <IoMdArrowRoundForward />
            </Link>
          </motion.div>
        </div>
      </div>
      {/* <footer>
          <span className="date">
            <FaRegClock className="icon"></FaRegClock>
            {date}
          </span>
        </footer> */}
      {/* </div> */}
    </Wrapper>
  )
}

const Wrapper = styled.article`
  * {
  }
  /* display: block; */
  /* flex-direction: column; */
  .grid {
    display: grid;
    /* display: none; */
    /* border: 2px solid green; */
  }
  margin-bottom: 3rem;
  .info {
    text-align: center;
  }
  .img {
    margin-bottom: 1rem;
    border-radius: var(--radius);
    /* height: 100px; */
    /* width: 100%; */
    box-shadow: 1px 1px 1px 0.5px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    /* background-color: black; */
    transform: scale(1);
    transition: transform 0.4s;
  }
  .img:hover {
    transform: translate3D(0, -1px, 0) scale(1.08);
    box-shadow: 8px 28px 50px rgba(39, 44, 49, 0.07),
      1px 6px 12px rgba(39, 44, 49, 0.04);
    transition: all 0.4s ease; /* zoom in */
    /* background: black; */
    /* opacity: 0.2; */
  }
  .category {
    display: inline-block;
    margin-bottom: 1rem;
    background: var(--clr-grey-10);
    padding: 0.25rem 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    border-radius: var(--radius);
    letter-spacing: var(--spacing);
    color: var(--clr-grey-5);
  }
  h3 {
    font-weight: 400;
    margin-bottom: 1rem;
    text-transform: initial;
  }
  .underline {
    width: 5rem;
    height: 1px;
    background: var(--clr-grey-9);
    margin: 0 auto;
    margin-bottom: 1rem;
  }
  p {
    color: var(--clr-grey-5);
    line-height: 1.8;
  }
  .link-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .link {
    background: #00e600;
    border-radius: 5px;
    width: 250px;
    padding: 10px 15px;
    text-transform: uppercase;
    letter-spacing: var(--spacing);
    font-weight: 700;
    color: var(--clr-primary-5);
    color: #fff;
    /* padding-bottom: 0.1rem; */
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      margin-left: 0.25rem;
      font-size: 1.2rem;
    }
  }
  .link:hover {
    border-color: var(--clr-primary-8);
    color: var(--clr-primary-8);
  }
  footer {
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px solid var(--clr-grey-9);
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--clr-grey-5);

    & .date {
      display: flex;
      align-items: center;
      & .icon {
        color: var(--clr-primary-5);
        margin-right: 0.5rem;
      }
    }
  }
  @media (min-width: 600px) {
    .img {
      /* height: 20rem; */
    }
  }
  @media (min-width: 800px) {
    .img {
      /* height: 25rem; */
      height: 250px;
    }
  }
  /* @media (min-width: 992px) {
    & {
      display: grid;
      grid-template-columns: 30rem 1fr;
      column-gap: 1.5rem;
      .info {
        text-align: left;
      }
      .img {
        height: 100%;
        max-height: 20rem;
      }
      .underline {
        margin-left: 0;
        margin-right: 0;
      }
    }
  } */
`

export default Project
